import { render, staticRenderFns } from "./CardStructure.vue?vue&type=template&id=5752d2f2"
import script from "./CardStructure.vue?vue&type=script&lang=js"
export * from "./CardStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports